import { useCancelSubscriptionMutationApi } from '@aibees/shared/api';
import {
  CancelSubscriptionReason,
  SubscriptionActiveAction,
} from '@aibees/shared/definition';
import { useCurrentSubscriptionApi } from '@aibees/shared/features/price-and-plan/api/use-current-subscription-api';
import { classnames } from '@aibees/shared/utils';
import { Button } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { DialogFooterProps as Props } from './types';

export const DialogFooter = memo(
  ({ className, closeModal, onCancel, onConfirm }: Props) => {
    const handleConfirm = () => {
      window.location.hash = '';
      onConfirm?.();
      closeModal();
    };

    const handleCancel = () => {
      onCancel?.();
      closeModal();
    };

    const { data } = useCurrentSubscriptionApi();

    const api = useCancelSubscriptionMutationApi(
      data && data?.next?.id,
      SubscriptionActiveAction.SCHEDULE
    );

    const handleCancelSubscription = () => {
      api
        .mutateAsync({ feedback: CancelSubscriptionReason.OTHER })
        .then(() => handleConfirm());
    };

    return (
      <Styled.Wrapper
        className={classnames('DialogFooter', className)}
        sx={SX.root}
      >
        <Button
          variant="text"
          color="inherit"
          onClick={handleCancelSubscription}
          size="small"
        >
          Cancel Downgrade
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleConfirm}
          size="small"
        >
          Continue
        </Button>
      </Styled.Wrapper>
    );
  }
);

DialogFooter.displayName = 'DialogFooter';
